/**
 * Checks if value is classified as a Number primitive and not NaN.
 *
 * @param value The value to check.
 * @return Returns true if value is correctly classified, else false.
 */
export const isNumber = (value: any) => {
  return typeof value === 'number' && !Number.isNaN(value);
};
